// custom navigator which can be used to route to the components which are outside of the hooks context
const CustomNavigator = {
    navigateHistory: null,
    navigate: (url, ...data) => CustomNavigator.navigateHistory(url, ...data),
};

export default CustomNavigator;